<template>
    <ContentOrLoading>
        <div v-if="!loadingButacas" class="card card-body card-outline card-outline-tabs">
            <PorPlanoButaca
                :plazas="butacas"
                :recinto_id="evento.place_id"
                :evento="evento"
                @recargar="getButacas"
            />
        </div>
    </ContentOrLoading>
</template>

<script>
    import PorPlanoButaca from './PorPlanoButaca.vue';

    export default {
        props: {
            evento_id: {
                type: Number,
                required: true
            },
            evento:{
                type: Object
            },
            sesion_id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                loadingButacas: false,
                butacas: null,
            }
        },
        created() {
            this.getButacas();
        },
        methods: {
            getButacas() {
                this.loadingButacas = true;

                const params = {
                    filters: {},
                    evento_id: this.evento_id,
                    recinto_id: this.evento.place_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.settings.butacas.visibilidad-reducida.index'), params).then(res => {
                    this.butacas = res.data.data;
                }).catch(() => {
                    console.warn('Error al recuperar las butacas de la sesión');
                }).finally(() => {
                    this.loadingButacas = false;
                });
            },
        },
        components: { PorPlanoButaca }
    }
</script>